
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/mapbox-search-js',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/mapbox-search-js/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/autofill/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core-autofill" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core_autofill.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/fetch/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core-fetch" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core_fetch.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/geography/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core-geography" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core_geography.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/search/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core-search" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core_search.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/core/search_session/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-core-search-session" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_core_search_session.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/react/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-react" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_react.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/react/autofill/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-react-autofill" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_react_autofill.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/react/hooks/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-react-hooks" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_react_hooks.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/react/minimap/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-react-minimap" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_react_minimap.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/react/search/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-react-search" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_react_search.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/autofill/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-autofill" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_autofill.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/config/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-config" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_config.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/events/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-events" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_events.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/minimap/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-minimap" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_minimap.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/properties/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-properties" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_properties.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/search/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-search" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_search.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/api/web/theming/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-api-web-theming" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_api_web_theming.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/autofill-checkout-js/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-autofill-checkout-js" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_autofill-checkout-js.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/autofill-checkout-react/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-autofill-checkout-react" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_autofill-checkout-react.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/autofill-events/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-autofill-events" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_autofill-events.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/confirm-address/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-confirm-address" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_confirm-address.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/japan-search-box/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-japan-search-box" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_japan-search-box.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/minimap/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-minimap" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_minimap.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/simple-autofill-custom-elements/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-simple-autofill-custom-elements" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_simple-autofill-custom-elements.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/simple-autofill/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-simple-autofill" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_simple-autofill.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/example/theming/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-example-theming" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_example_theming.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/examples/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-examples" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_examples.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/autofill/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-autofill" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_autofill.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/browsers-and-testing/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-browsers-and-testing" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_browsers-and-testing.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/changelog/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-changelog" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_changelog.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-install" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_install.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-pricing" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_pricing.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/guides/search/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-guides-search" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_guides_search.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/overview/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-overview" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_overview.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/tutorials/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-tutorials" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_tutorials.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/tutorials/add-address-autofill-to-your-website/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-tutorials-add-address-autofill-to-your-website" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_tutorials_add-address-autofill-to-your-website.js'
            ),
            
            
          },{
            path: '/mapbox-search-js/tutorials/add-address-autofill-with-react/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-search-js-tutorials-add-address-autofill-with-react" */
              '/work/search-js-docs/_batfish_tmp/_mapbox-search-js_tutorials_add-address-autofill-with-react.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };